<div>
	<!-- Intentional NOOP -->
	<!-- This component is not visual -->
</div>